module.exports = __webpack_public_path__ + "media/images/kaoawase/top/plan/plan1-7ffad4dc70a5fd363f5aa4eec305dc83.jpg";